/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Container, Card, CardBody, Row, Col, Table } from 'reactstrap';
import moment from 'moment';
import { Page, PDFDownloadLink } from '@react-pdf/renderer';

import { SubHeader } from '~/components/SubHeader';
import { LoaderMini } from '~/components/Loaders';
import { color } from '~/assets/styles/colors';

import { CardBodyDirf } from './styles';
import { MyDocument } from './print';
import apiDift from './helpers/apiDift';

function Dirf() {
	const { user } = useSelector((state) => state.auth);

	const [listagem, setListagem] = useState({
		lista: [],
		loading: true,
	});

	const [loading, setLoading] = useState(true);

	const [anoGerado, setAnoGerado] = useState('');

	const [loja, setLoja] = useState({
		cnpj: '',
		nome: '',
	});

	const [totais, setTotais] = useState({
		rendimentos: 'R$',
		retido: 'R$',
	});

	const [token, setToken] = useState('');

	useEffect(() => {
		apiDift.setToken().then((resposta) => {
			setToken(resposta);
		});
	}, []);

	useEffect(() => {
		if (token !== '') {
			apiDift.fiscal
				.getDirf(token, user.dados.documento)
				.then((respostadirf) => {
					setAnoGerado(
						respostadirf.data.data.dirfs[0].data_fato_gerado.substr(
							0,
							4
						)
					);

					setListagem({
						lista: respostadirf.data.data.dirfs,
					});
					setLoja({
						cnpj: respostadirf.data.data.cnpj_cliente,
						nome: respostadirf.data.data.nome_cliente,
					});
					let rendimentos = 0;
					let retido = 0;
					for (
						let i = 0;
						i < respostadirf.data.data.dirfs.length;
						i++
					) {
						rendimentos +=
							respostadirf.data.data.dirfs[i].rendimentos;

						retido += respostadirf.data.data.dirfs[i].retido;
					}

					setLoading(false);

					setTotais({
						rendimentos: (
							Math.round(rendimentos * 100) / 100
						).toLocaleString('pt-br', {
							style: 'currency',
							currency: 'BRL',
						}),
						retido: (Math.round(retido * 100) / 100).toLocaleString(
							'pt-br',
							{
								style: 'currency',
								currency: 'BRL',
							}
						),
					});
				})
				.catch((error) => {
					setLoading(false);

					setListagem({
						lista: [],
						loading: true,
						error,
					});
				});
		}
	}, [token]);

	return (
		<Page>
			<Container fluid>
				<SubHeader
					breadcrumb={[
						{
							page: 'Dirf',
							link: '/client/dirf',
						},
					]}
				/>
				<div>
					<Card className="py-2">
						<CardBody>
							<Row>
								<Col md="12">
									<Row>
										<Col>Prezado(a) Cliente,</Col>
									</Row>
								</Col>
							</Row>
							<Row style={{ marginTop: 20 }}>
								<Col>
									O documento que você está recebendo é um
									informe para o preenchimento de sua DIRF
									(Declaração do Imposto de Renda Retido na
									Fonte) anual.
								</Col>
							</Row>
							<Row style={{ marginTop: 20 }}>
								<Col>
									Conforme o disposto no artigo 224, inciso
									III e XVII, da Instrução Normativa nº 888,
									de 19 de novembro de 2008, da Receita
									Federal do Brasil (publicado no D.O.U. de
									10.12.2008), os rendimentos e o respectivo
									Imposto de Renda retido na fonte devem ser
									informados na DIRF da pessoa jurídica que
									tenha pago a outras pessoas jurídicas
									jurídicas importâncias a título de comissões
									e corretagens, relativas à administração de
									crédito em geral.
								</Col>
							</Row>

							<Row style={{ marginTop: 20 }}>
								<Col>
									Em caso de dúvida, entre em contato com a
									nossa Central de Atendimento.
								</Col>
							</Row>

							<Row style={{ marginTop: 20 }}>
								<Col>Atenciosamente,</Col>
							</Row>

							<Row style={{ marginTop: 20 }}>
								<Col>Lucree Soluções Inteligentes S.A.</Col>
							</Row>
						</CardBody>
					</Card>

					<Row className="py-2">
						<Col>
							<strong>
								{`DIRF ANUAL – CALENDÁRIO ${anoGerado}`}
							</strong>
						</Col>
					</Row>

					<Card>
						{loading ? (
							<div className="d-flex justify-content-center">
								<LoaderMini width="100" />
							</div>
						) : loja.nome !== '' && loja.cnpj !== '' ? (
							<Row style={{ marginLeft: 0, marginRight: 0 }}>
								<CardBodyDirf
									style={{
										paddingTop: 0,
										border: `1px solid ${color.primary}`,
									}}>
									<Row
										style={{
											backgroundColor: color.primary,
											borderRight: `1px solid ${color.white}`,
										}}>
										<Col
											style={{
												color: color.white,
												marginTop: 10,
												marginBottom: 10,
											}}>
											<strong>Rendimento</strong>
										</Col>
									</Row>
									<Row style={{ marginTop: 10 }}>
										<Col>
											<p>
												<strong
													style={{
														marginRight: '2px',
													}}>
													Descrição:
												</strong>
												Administração de cartão de
												crédito ou débito e congêneres.
											</p>
										</Col>
									</Row>
									<Row style={{ marginTop: 10 }}>
										<Col>
											<p>
												<strong
													style={{
														marginRight: '2px',
													}}>
													Código de retenção:
												</strong>
												8045-Comissões e corretagens
												pagas à pessoa jurídica.
											</p>
										</Col>
									</Row>
									<Row style={{ marginTop: 10 }}>
										<Col>
											<p>
												<strong
													style={{
														marginRight: '2px',
													}}>
													Referência:
												</strong>
												{anoGerado}
											</p>
										</Col>
									</Row>
								</CardBodyDirf>

								<CardBody
									style={{
										paddingTop: 0,
										border: `1px solid ${color.primary}`,
									}}>
									<Row
										style={{
											backgroundColor: color.primary,
										}}>
										<Col
											style={{
												color: color.white,
												marginTop: 10,
												marginBottom: 10,
											}}>
											<strong>Estabelecimento</strong>
										</Col>
									</Row>
									<Row style={{ marginTop: 10 }}>
										<Col>
											<p>
												<strong>Razão social: </strong>
												{loja.nome}
											</p>
										</Col>
									</Row>

									<Row style={{ marginTop: 10 }}>
										<Col>
											<p>
												<strong>CNPJ: </strong>
												{loja.cnpj}
											</p>
										</Col>
									</Row>
								</CardBody>
							</Row>
						) : (
							<CardBody>
								<Row style={{ marginTop: 10 }}>
									<Col>
										<p>
											<strong>
												Nenhum dado encontrado.
											</strong>
										</p>
									</Col>
								</Row>
							</CardBody>
						)}
					</Card>

					<Row className="py-2">
						<Col>
							<strong>TOTAIS</strong>
						</Col>
					</Row>
					<Card>
						{loading ? (
							<div className="d-flex justify-content-center">
								<LoaderMini width="100" />
							</div>
						) : totais.rendimentos !== 'R$' &&
						  totais.recebido !== 'R$' ? (
							<Row style={{ marginLeft: 0, marginRight: 0 }}>
								<CardBody
									style={{
										paddingTop: 0,
										border: `1px solid ${color.primary}`,
									}}>
									<Row
										style={{
											backgroundColor: color.primary,
											borderRight: `1px solid ${color.white}`,
										}}>
										<Col
											style={{
												color: color.white,
												marginTop: 10,
												marginBottom: 10,
											}}>
											<strong>Rendimento</strong>
										</Col>
									</Row>
									<Row
										style={{
											marginTop: 10,
										}}>
										<Col>
											<p>{totais.rendimentos}</p>
										</Col>
									</Row>
								</CardBody>

								<CardBody
									style={{
										paddingTop: 0,
										border: `1px solid ${color.primary}`,
									}}>
									<Row
										style={{
											backgroundColor: color.primary,
										}}>
										<Col
											style={{
												color: color.white,
												marginTop: 10,
												marginBottom: 10,
											}}>
											<strong>IRRF Retido</strong>
										</Col>
									</Row>
									<Row style={{ marginTop: 10 }}>
										<Col>
											<p>{totais.retido}</p>
										</Col>
									</Row>
								</CardBody>
							</Row>
						) : (
							<CardBody>
								<Row style={{ marginTop: 10 }}>
									<Col>
										<p>
											<strong>
												Nenhum dado encontrado.
											</strong>
										</p>
									</Col>
								</Row>
							</CardBody>
						)}
					</Card>

					<Row className="py-2">
						<Col>
							<strong>DETALHES RENDIMENTOS</strong>
						</Col>
					</Row>
					<Card>
						{loading ? (
							<div className="d-flex justify-content-center">
								<LoaderMini width="100" />
							</div>
						) : listagem.lista[0] ? (
							<Row style={{ marginLeft: 0, marginRight: 0 }}>
								<Table style={{ marginBottom: 0 }}>
									<tr>
										<th
											style={{
												marginBottom: 0,
												border: `1px solid ${color.white}`,
												backgroundColor: color.primary,
												color: color.white,
											}}>
											Mês
										</th>
										<th
											style={{
												marginBottom: 0,
												border: `1px solid ${color.white}`,
												backgroundColor: color.primary,
												color: color.white,
											}}>
											Num. NF
										</th>
										<th
											style={{
												border: `1px solid ${color.white}`,
												backgroundColor: color.primary,
												color: color.white,
											}}>
											Rendimentos
										</th>
										<th
											style={{
												border: `1px solid ${color.white}`,
												backgroundColor: color.primary,
												color: color.white,
											}}>
											IRRF Retido
										</th>
									</tr>
									{listagem.lista.map((item) => (
										<tr key={item.num_nf}>
											<td
												style={{
													border: `1px solid ${color.primary}`,
													textAlign: 'left',
												}}>
												{moment(
													item.data_fato_gerado,
													'YYYY-MM-DD'
												)
													.format('MMMM')
													.toUpperCase()}
											</td>
											<td
												style={{
													border: `1px solid ${color.primary}`,
													textAlign: 'left',
												}}>
												{item.num_nf}
											</td>
											<td
												style={{
													border: `1px solid ${color.primary}`,
													textAlign: 'left',
													padding: 8,
												}}>
												{item.rendimentos.toLocaleString(
													'pt-br',
													{
														style: 'currency',
														currency: 'BRL',
													}
												)}
											</td>
											<td
												style={{
													border: `1px solid ${color.primary}`,
													textAlign: 'left',
													padding: 8,
												}}>
												{item.retido.toLocaleString(
													'pt-br',
													{
														style: 'currency',
														currency: 'BRL',
													}
												)}
											</td>
										</tr>
									))}
								</Table>
							</Row>
						) : (
							<CardBody>
								<Row style={{ marginTop: 10 }}>
									<Col>
										<p>
											<strong>
												Nenhum dado encontrado.
											</strong>
										</p>
									</Col>
								</Row>
							</CardBody>
						)}
					</Card>

					<div
						style={{
							display: 'flex',
							justifyContent: 'end',
							marginBottom: 40,
						}}>
						{loja.cnpj !== '' &&
							totais.rendimentos !== 'R$' &&
							listagem.lista[0] && (
								<PDFDownloadLink
									document={
										<MyDocument
											loja={loja}
											totais={totais}
											listagem={listagem}
											anoGerado={anoGerado}
										/>
									}
									fileName="dirf.pdf"
									style={{
										textDecoration: 'none',
										color: color.black,
										borderRadius: 50,
										fontSize: 18,
										fontWeight: 'bold',
										padding: 20,
										paddingLeft: 40,
										paddingRight: 40,
										backgroundColor: color.yellow,
									}}>
									IMPRIMIR
								</PDFDownloadLink>
							)}
					</div>
				</div>
			</Container>
		</Page>
	);
}

export default Dirf;
